import Vue from 'vue'
import Router from 'vue-router'
const originalPush = Router.prototype.push
  Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)
const manage = r => require.ensure([], () => r(require('@/page/manage')), 'manage');
const index = r => require.ensure([], () => r(require('@/page/index')), 'index');
const customerManagement = r => require.ensure([], () => r(require('@/page/customerManagement')), 'customerManagement');
const login = r => require.ensure([], () => r(require('@/page/login')), 'login');
const customerManagementDetails = r => require.ensure([], () => r(require('@/page/customerManagementDetails')), 'customerManagementDetails');
const auditInformation = r => require.ensure([], () => r(require('@/page/auditInformation')), 'auditInformation');
const certification = r => require.ensure([], () => r(require('@/page/certification')), 'certification');
const pendingOrders = r => require.ensure([], () => r(require('@/page/pendingOrders')), 'pendingOrders');
const pendingOrder = r => require.ensure([], () => r(require('@/page/pendingOrder')), 'pendingOrder');
const allOrders = r => require.ensure([], () => r(require('@/page/allOrders')), 'allOrders');
const customerOrderManagement = r => require.ensure([], () => r(require('@/page/customerOrderManagement')), 'customerOrderManagement');
const userManagement = r => require.ensure([], () => r(require('@/page/userManagement')), 'userManagement');


const finishOrderManagement = r => require.ensure([], () => r(require('@/page/finishOrderManagement')), 'finishOrderManagement');
const allRentalOrders = r => require.ensure([], () => r(require('@/page/allRentalOrders')), 'allRentalOrders');
const payRentToday = r => require.ensure([], () => r(require('@/page/payRentToday')), 'payRentToday');
const payRentTomorrow = r => require.ensure([], () => r(require('@/page/payRentTomorrow')), 'payRentTomorrow');
const orderDetails = r => require.ensure([], () => r(require('@/page/orderDetails')), 'orderDetails');
const lateOrder = r => require.ensure([], () => r(require('@/page/lateOrder')), 'lateOrder');
const collectionOrder = r => require.ensure([], () => r(require('@/page/collectionOrder')), 'collectionOrder');
const badDebtOrders = r => require.ensure([], () => r(require('@/page/badDebtOrders')), 'badDebtOrders');
const fundingDetails = r => require.ensure([], () => r(require('@/page/fundingDetails')), 'fundingDetails');
const fundingYQDetails = r => require.ensure([], () => r(require('@/page/fundingYQDetails')), 'fundingYQDetails');


const fundStatistics = r => require.ensure([], () => r(require('@/page/fundStatistics')), 'fundStatistics');
const categoryStatistics = r => require.ensure([], () => r(require('@/page/categoryStatistics')), 'categoryStatistics');

const commissionPaid = r => require.ensure([], () => r(require('@/page/commissionPaid')), 'commissionPaid');
const commissionUnpaid = r => require.ensure([], () => r(require('@/page/commissionUnpaid')), 'commissionUnpaid');
const commissionsAll = r => require.ensure([], () => r(require('@/page/commissionsAll')), 'commissionsAll');


const firstClass = r => require.ensure([], () => r(require('@/page/firstClass')), 'firstClass');
const secondaryClass = r => require.ensure([], () => r(require('@/page/secondaryClass')), 'secondaryClass');



const commodity = r => require.ensure([], () => r(require('@/page/commodity')), 'commodity');
const accessories = r => require.ensure([], () => r(require('@/page/accessories')), 'accessories');
const addCommodity = r => require.ensure([], () => r(require('@/page/addCommodity')), 'addCommodity');
const goodsListConfg = r => require.ensure([], () => r(require('@/page/goodsListConfg')), 'goodsListConfg');

const staffManagement = r => require.ensure([], () => r(require('@/page/staffManagement')), 'staffManagement');
const roleManagement = r => require.ensure([], () => r(require('@/page/roleManagement')), 'roleManagement');
const parameterSettings = r => require.ensure([], () => r(require('@/page/parameterSettings')), 'parameterSettings');


const HelloWorld = r => require.ensure([], () => r(require('@/components/HelloWorld')), 'HelloWorld');

const routes = [
  // {
  //   path: "/",
  //   component: HelloWorld,
  //   name: "HelloWorld",
  // },
  {
    path: "/",
    component: login,
    name: "login",
  },
  {
    path: '/manage',
    name: '/manage',
    component: manage,
    children: [{
      path: '',
      name: '',
      meta: [],
    },
    {
      path: '/index',
      name:'index',
      component: index,
      meta: {
        breadcrumb:['首页'],
        defaultActive:'1'
      }
    },
    {
      path: '/customerManagement',
      name:'customerManagement',
      component: customerManagement,
      meta: {
        breadcrumb:['客户管理'],
        defaultActive:'2'
      }
    },
    {
      path: '/userManagement',
      name:'userManagement',
      component: userManagement,
      meta: {
        breadcrumb:['申请管理'],
        defaultActive:'11'
      }
    },
    
    {
      path: '/customerManagementDetails',
      name:'customerManagementDetails',
      component: customerManagementDetails,
      meta: {
        breadcrumb:['客户管理详情'],
        defaultActive:'2'
      }
    },
    {
      path: '/auditInformation',
      name:'auditInformation',
      component: auditInformation,
      meta: {
        breadcrumb:['客户管理详情','审核资料'],
        defaultActive:'2'
      }
    },
    {
      path: '/certification',
      name:'certification',
      component: certification,
      meta: {
        breadcrumb:['资质认证'],
        defaultActive:'3'
      }
    },
    {
      path: '/pendingOrders',
      name:'pendingOrders',
      component: pendingOrders,
      meta: {
        breadcrumb:['待发货订单'],
        defaultActive:'4-1'
      }
    },
    {
      path: '/pendingOrder',
      name:'pendingOrder',
      component: pendingOrder,
      meta: {
        breadcrumb:['待签收订单'],
        defaultActive:'4-2'
      }
    },
    {
      path: '/customerOrderManagement',
      name:'customerOrderManagement',
      component: customerOrderManagement,
      meta: {
        breadcrumb:['客户订单管理'],
        defaultActive:'5-1'
      }
    },
    {
      path: '/allRentalOrders',
      name:'allRentalOrders',
      component: allRentalOrders,
      meta: {
        breadcrumb:['租赁订单管理'],
        defaultActive:'5-2'
      }
    },
    {
      path: '/finishOrderManagement',
      name:'finishOrderManagement',
      component: finishOrderManagement,
      meta: {
        breadcrumb:['完结订单管理'],
        defaultActive:'5-3'
      }
    },
    {
      path: '/payRentToday',
      name:'payRentToday',
      component: payRentToday,
      meta: {
        breadcrumb:['今日付租查询'],
        defaultActive:'5-4'
      }
    },
    {
      path: '/payRentTomorrow',
      name:'payRentTomorrow',
      component: payRentTomorrow,
      meta: {
        breadcrumb:['明日付租查询'],
        defaultActive:'5-5'
      }
    },
    {
      path: '/allOrders',
      name:'allOrders',
      component: allOrders,
      meta: {
        breadcrumb:['所有租赁订单'],
        defaultActive:'5-6'
      }
    },
    {
      path: '/orderDetails',
      name:'orderDetails',
      component: orderDetails,
      meta: {
        breadcrumb:['订单详情'],
        defaultActive:'5-1'
      }
    },
    {
      path: '/lateOrder',
      name:'lateOrder',
      component: lateOrder,
      meta: {
        breadcrumb:['逾期订单'],
        defaultActive:'6-1'
      }
    },
    {
      path: '/collectionOrder',
      name:'collectionOrder',
      component: collectionOrder,
      meta: {
        breadcrumb:['催收订单'],
        defaultActive:'6-2'
      }
    },
    {
      path: '/badDebtOrders',
      name:'badDebtOrders',
      component: badDebtOrders,
      meta: {
        breadcrumb:['坏账订单'],
        defaultActive:'6-3'
      }
    },
    {
      path: '/fundingDetails',
      name:'fundingDetails',
      component: fundingDetails,
      meta: {
        breadcrumb:['资金明细'],
        defaultActive:'7-1'
      }
    }
    ,
    {
      path: '/fundingYQDetails',
      name:'fundingYQDetails',
      component: fundingYQDetails,
      meta: {
        breadcrumb:['违约金明细'],
        defaultActive:'7-4'
      }
    }
    ,
    {
      path: '/fundStatistics',
      name:'fundStatistics',
      component: fundStatistics,
      meta: {
        breadcrumb:['资金统计'],
        defaultActive:'7-2'
      }
    },
    {
      path: '/categoryStatistics',
      name:'categoryStatistics',
      component: categoryStatistics,
      meta: {
        breadcrumb:['类目统计'],
        defaultActive:'7-3'
      }
    },
    {
      path: '/commissionPaid',
      name:'commissionPaid',
      component: commissionPaid,
      meta: {
        breadcrumb:['已付佣金'],
        defaultActive:'8-1'
      }
    },
    {
      path: '/commissionUnpaid',
      name:'commissionUnpaid',
      component: commissionUnpaid,
      meta: {
        breadcrumb:['未付佣金'],
        defaultActive:'8-2'
      }
    },
    {
      path: '/commissionsAll',
      name:'commissionsAll',
      component: commissionsAll,
      meta: {
        breadcrumb:['所有佣金'],
        defaultActive:'8-3'
      }
    },
    {
      path: '/firstClass',
      name:'firstClass',
      component: firstClass,
      meta: {
        breadcrumb:['一级类别'],
        defaultActive:'9-1-1'
      }
    },
    {
      path: '/secondaryClass',
      name:'secondaryClass',
      component: secondaryClass,
      meta: {
        breadcrumb:['二级类别'],
        defaultActive:'9-1-2'
      }
    },
    
    {
      path: '/accessories',
      name:'accessories',
      component: accessories,
      meta: {
        breadcrumb:['配件'],
        defaultActive:'9-2'
      }
    },
    {
      path: '/commodity',
      name:'commodity',
      component: commodity,
      meta: {
        breadcrumb:['商品'],
        defaultActive:'9-3'
      }
    },
    {
      path: '/addCommodity',
      name:'addCommodity',
      component: addCommodity,
      meta: {
        breadcrumb:['商品','添加商品'],
        defaultActive:'9-3'
      }
    },
    {
      path: '/goodsListConfg',
      name:'goodsListConfg',
      component: goodsListConfg,
      meta: {
        breadcrumb:['商品','商品价格列表'],
        defaultActive:'9-3'
      }
    },
    

    {
      path: '/staffManagement',
      name:'staffManagement',
      component: staffManagement,
      meta: {
        breadcrumb:['员工管理'],
        defaultActive:'10-1'
      }
    },
    {
      path: '/roleManagement',
      name:'roleManagement',
      component: roleManagement,
      meta: {
        breadcrumb:['角色管理'],
        defaultActive:'10-2'
      }
    },
    {
      path: '/parameterSettings',
      name:'parameterSettings',
      component: parameterSettings,
      meta: {
        breadcrumb:['参数设置'],
        defaultActive:'10-3'
      }
    },
  ]}
]

export default new Router({
  routes,
  // strict: process.env.NODE_ENV !== 'production',
})



// WEBPACK FOOTER //
// ./src/router/index.js